import { CircularProgress } from '@mui/material';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import { processStatuses, Statuses } from '../../../types';

export const GetImportIcon = ({ status }: { status: Statuses }) => {
  if (status === processStatuses.processing) return <CircularProgress size="20px" />;

  if (status === processStatuses.finished) return <TaskAltIcon color="success" />;

  if (status === processStatuses.failed) return <ErrorOutlineIcon color="error" />;

  return <CancelOutlinedIcon color="disabled" />;
};
